import { Box } from '@mui/material';
import { Outlet } from '@tanstack/react-router';
import CleaningBottomBar from './CleaningBottomBar';

const CleaningLayout = () => (
  <Box sx={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
    <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
      <Outlet />
    </Box>
    <CleaningBottomBar />
  </Box>
);

export default CleaningLayout;
